/* unplugin-vue-components disabled */import script from "./xFormPropView.vue?vue&type=script&lang=jsx&setup=true"
export * from "./xFormPropView.vue?vue&type=script&lang=jsx&setup=true"

const __exports__ = script;

export default __exports__